<template>
  <nav
    ref="navBar"
    class="navbar navbar-dark fixed-top bg-primary"
    :class="{'nav-up':!showHeader}"
    @click="scrollToTop"
  >
    <div class="container-fluid">
      <div class="navbar-header nav-title-menu">
        <transition name="fade">
          <a v-if="isLoggedIn && isArmWithPortal && !hideNavigationButton" type="button" class="float-left portal-nav-toggle d-lg-none" @click.stop.prevent="toggleNav">
            <div class="animated-icon" :class="{open: showNavigation}"><span /><span /><span /></div>
          </a>
        </transition>

        <span v-if="!isUsingNewEnrollment" class="navbar-study-brand">
          {{ $store.getters.getPortalStudyName }}
        </span>
        <router-link v-else :to="{name: isLoggedIn ? 'dashboard' : 'home'}" class="navbar-study-brand">
          {{ $store.getters.getPortalStudyName }}
        </router-link>
      </div>
      <div class="navbar-header nav-actions">
        <ul class="nav navbar-nav portal-top-nav">
          <li v-if="isLoggedIn && isParticipant" class="mr-2" :class="{active: $route.name === 'profile'}">
            <router-link class="nav-link px-2" :to="{name: 'profile'}">
              <span class="fa fa-user" />
              <span class="d-none d-md-inline"> {{ $t('profile') }}</span>
            </router-link>
          </li>
          <li v-if="isLoggedIn && isParticipant" class="mr-2" :class="{active: showNotifications}">
            <a href="#" class="nav-link px-2" @click.stop.prevent="toggleNotifications">
              <span class="fa fa-inbox" />
              <span class="d-none d-md-inline"> {{ $t('notifications') }}</span>
            </a>
          </li>
          <li class="nav-item" v-if="!isLoggedIn && isUsingNewEnrollment && isLoginEnabled">
            <router-link :to="{name: 'login'}" class="nav-link">
              {{ $t('signIn') }}
            </router-link>
          </li>
          <li v-if="isLoggedIn && isParticipant">
            <router-link class="nav-link px-2" :to="{name: 'logout'}">
              <span class="fa fa-sign-out-alt" />
              <span class="d-none d-md-inline"> {{ $t('signOut') }} </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  import { throttle } from 'lodash-es';

  export default {
    name: "Header",
    data: function() {
      return {
        lastScrollTop: 0,
        delta: 0,
      }
    },
    computed: {
      isLoginEnabled() {
        return this.$store.getters.isLoginEnabled;
      },
      isLoggedIn() {
        return this.$store.getters.isLoggedIn;
      },
      isParticipant() {
        return !!this.$store.getters.getParticipant;
      },
      isArmWithPortal() {
        return this.$store.getters.isArmWithPortal;
      },
      showNotifications() {
        return this.$store.state.showNotifications;
      },
      showNavigation() {
        return this.$store.state.showNavigation;
      },
      showHeader() {
        return this.$store.state.showHeader;
      },
      hideNavigationButton() {
        return this.$store.state.hideNavigationButton;
      },
      isUsingNewEnrollment() {
        return this.$store.state.study.configuration &&
               this.$store.state.study.configuration.enrollment &&
               this.$store.state.study.configuration.enrollment.enable_new_enrollment;
      }
    },
    created: function () {
      window.addEventListener('scroll', throttle(this.handleScroll, 250));
      window.addEventListener('focus', this.showNav);

    },
    destroyed: function () {
      window.removeEventListener('scroll', throttle(this.handleScroll, 250));
      window.removeEventListener('focus', this.showNav);

    },
    methods: {
      toggleNav() {
        this.$store.commit('TOGGLE_NAVIGATION');
      },
      toggleNotifications() {
        this.scrollToTopNotifications();
        this.$store.dispatch('TOGGLE_NOTIFICATIONS');
      },
      scrollToTop: function() {
        if (window.innerWidth < 768) {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.scrollToTopNotifications();
        }
      },
      scrollToTopNotifications: function() {
        let notificationPanel = document.getElementsByClassName('portal-notifications-panel');
        if (notificationPanel.length > 0) {
          notificationPanel[0].scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }
      },
      handleScroll: function() {
        if (window.innerWidth < 768 && !this.showNotifications) {
          var scrollTop = document.documentElement.scrollTop;
          var navBar = this.$refs.navBar;

          // Make sure they scroll more than delta
          if (Math.abs(this.lastScrollTop - scrollTop) <= this.delta) {
            return;
          }

          if (scrollTop > this.lastScrollTop && scrollTop > navBar.clientHeight) {
            // Scroll Down
            this.hideNav();
          } else {
            // Scroll Up
            if (scrollTop + window.innerHeight < document.body.scrollHeight) {
              this.showNav();
            }
          }
          this.lastScrollTop = scrollTop;
        } else {
          this.showNav();
        }
      },
      showNav: function() {
        this.$store.commit('SET_SHOW_HEADER', true);
      },
      hideNav: function() {
        this.$store.commit('SET_SHOW_HEADER', false);
      }
    },
  }

</script>

<style scoped>
  .navbar {
    top: 0;
    transition: top 0.2s ease-in-out;
    width: 100%;
  }

  .container-fluid {
    display: flex;
  }

  .container-fluid > .navbar-header {
    /*display: flex;*/
    margin-left: 0;
    margin-right: 0;
  }

  .nav-up {
    top: -50px;
  }

  .nav-title-menu {
    justify-content: flex-start;
    flex-grow: 2;
    flex-shrink: 1;
    flex-basis: 0;
  }
  .nav-actions {
    justify-content: flex-end;
  }

  .navbar-study-brand {
    /*display: flex;*/
    text-align: left;
    align-items: center;
    margin-left: -15px;
    float: left;
    height: 50px;
    padding: 15px 0 15px 15px;
    line-height: 20px;
    color: #fff;

    /*  This starts our font size at a maximum 18px for full width (1200px) screens.
        Then linearly scales down to a minimum 12px for screens as small as 300px
        *see https://css-tricks.com/snippets/css/fluid-typography/ */
    /* calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width]))); */
    font-size: calc(14px + (18 - 12) * ((100vw - 300px) / (1200 - 300)));
  }

  .navbar-study-brand:hover {
    color: #e6e6e6;
    background-color: transparent;
    text-decoration: none;

  }

  /* undo a few bootstrap mobile styles */
  .portal-top-nav {
    /*margin: 0;*/
    flex-direction: row;
    /*display: flex;*/
    /*flex-wrap: nowrap;*/
  }

  .portal-top-nav > li > a {
    /*padding-top: 15px;*/
    /*padding-bottom: 15px;*/
  }

</style>


<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s ease-in-out;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }

  .portal-nav-toggle {
    padding: 15px 15px 15px 0;
  }

  .animated-icon {
    width: 30px;
    height: 20px;
    position: relative;
    margin: 0px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
  }

  .animated-icon span {
    display: block;
    position: absolute;
    height: 3px;
    width: 100%;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
    background: #f3e5f5;
  }


  .animated-icon span:nth-child(1) {
    top: 0px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  .animated-icon span:nth-child(2) {
    top: 10px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  .animated-icon span:nth-child(3) {
    top: 20px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  .animated-icon.open span:nth-child(1) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
    top: 0px;
    left: 8px;
  }

  .animated-icon.open span:nth-child(2) {
    width: 0%;
    opacity: 0;
  }

  .animated-icon.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 21px;
    left: 8px;
  }
</style>
